// extracted by mini-css-extract-plugin
export default {"fluent-provider":"j_uqAbdbToFVl4HEaOkr"};